import './index.scss';

(function ($) {
  'use strict';

  $(() => {
    $('.js-floating-labels')
      .on('blur', '.form-control', function () {
        const $this = $(this);
        $this.parents('.q-floating-label-wrapper').removeClass('q-floating-label-wrapper--focused');
        if ($this.val() === '')
          $this.parents('.q-floating-label-wrapper').removeClass('q-floating-label-wrapper--filled');
        else
          $this.parents('.q-floating-label-wrapper').addClass('q-floating-label-wrapper--filled');
      })
      .on('focus', '.form-control', function () {
        $(this).parents('.q-floating-label-wrapper').addClass('q-floating-label-wrapper--focused');
      })
      .find('.form-control')
      .each(function () {
        const $this = $(this);
        let isAutofill = false;

        try {
          isAutofill = $this.is(':-webkit-autofill');
        } catch (e) {
          isAutofill = false;
        }

        if ($this.val() !== '' || isAutofill)
          $this.parents('.q-floating-label-wrapper').addClass('q-floating-label-wrapper--filled');
      });

  });

})(jQuery);
